import styled from 'styled-components'

interface Props {
  src: string
}

export const Badge = styled.span<Props>`
  width: 40%;
  padding-top: 40%;
  margin-left: 5%;
  background-image: url(${(props) => props.src});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`
